import * as React from "react";

 export function ActionButton(props) {
  return (
    <>
      <button className="actionButton" style={props.style} onClick={props.onClick} >{props.buttonName}</button>
    </>
  );
}